import React from 'react';
import { useColorMode } from '../../contexts/ColorModeContext';

const LIGHT_COLOR = '#3C3A3A';
const DARK_COLOR = '#D9D9D9';

interface VellumProIconFlatProps {
  /**
   * Override the resolved fill color. Useful on fixed-color surfaces (e.g. a
   * dark landing page hero) where the theme-aware default would be invisible.
   */
  color?: string;
  /** Width and height of the icon in pixels (it is square). Default: 16. */
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Renders the Vellum Pro four-pointed star as a single-color icon.
 * Fill adapts to colour mode: #3C3A3A in light mode, #D9D9D9 in dark mode.
 * Pass `color` to override (e.g. "#BAA87B" for gold on dark backgrounds).
 */
export function VellumProIconFlat({ color, size = 16, className, style }: VellumProIconFlatProps) {
  const { resolvedMode } = useColorMode();
  const fill = color ?? (resolvedMode === 'dark' ? DARK_COLOR : LIGHT_COLOR);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 394 394"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ flexShrink: 0, ...style }}
      aria-label="Vellum Pro"
      role="img"
    >
      <path
        d="M183.507 9.74962C187.84 -3.24987 206.197 -3.24987 210.53 9.74962L235.938 86.0527C241.531 102.826 250.953 118.066 263.459 130.565C275.965 143.064 291.21 152.479 307.987 158.062L384.25 183.47C397.25 187.803 397.25 206.16 384.25 210.493L307.947 235.901C291.174 241.494 275.934 250.917 263.435 263.423C250.936 275.928 241.521 291.174 235.938 307.95L210.53 384.214C209.596 387.06 207.786 389.539 205.36 391.296C202.934 393.054 200.014 394 197.018 394C194.022 394 191.103 393.054 188.677 391.296C186.25 389.539 184.441 387.06 183.507 384.214L158.099 307.911C152.51 291.142 143.093 275.904 130.595 263.405C118.096 250.907 102.858 241.49 86.0893 235.901L9.78625 210.493C6.93971 209.559 4.46093 207.75 2.70356 205.323C0.946184 202.897 0 199.978 0 196.982C0 193.986 0.946184 191.066 2.70356 188.64C4.46093 186.214 6.93971 184.404 9.78625 183.47L86.0893 158.062C102.858 152.473 118.096 143.057 130.595 130.558C143.093 118.059 152.51 102.822 158.099 86.0527L183.507 9.74962Z"
        fill={fill}
      />
    </svg>
  );
}
